export default __webpack_public_path__ + "static/media/Woodcut_xs.73808d9d.png";